import CircularProgress from '@material-ui/core/CircularProgress';
import { useEffect } from 'react';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { Toast } from '~/common/components';
import { routes } from '~/constants';
import { Request, useCreateRequest } from '~/root/Requests';

const QUERY_PARAM = {
  token: 'token',
  type: 'type',
} as const;

type RequestType = Request['type'];

type RequestConfig = {
  successMessage: string;
  redirectTo: string;
};

const REQUEST_CONFIG: Record<RequestType, RequestConfig> = {
  'email-change': {
    successMessage: 'Your email address has been changed successfully.',
    redirectTo: routes.profile.user_details,
  },
  'transfer-ownership': {
    successMessage: 'The ownership transfer is confirmed successfully.',
    redirectTo: routes.profile.orders,
  },
};

const DEFAULT_REQUEST_CONFIG: RequestConfig = {
  successMessage: 'The request has been confirmed successfully.',
  redirectTo: routes.profile.orders,
};

const isKnownRequestType = (value: string | null): value is RequestType =>
  !!value && value in REQUEST_CONFIG;

export const RequestsPage = () => {
  const { id } = useParams<{ id: string }>();
  const { search } = useLocation();
  const history = useHistory();

  const createRequest = useCreateRequest();

  useEffect(() => {
    const params = new URLSearchParams(search);
    const token = params.get(QUERY_PARAM.token);
    const type = params.get(QUERY_PARAM.type);

    if (!id || !token) {
      history.replace(routes.profile.orders);
      return;
    }

    const { successMessage, redirectTo } = isKnownRequestType(type)
      ? REQUEST_CONFIG[type]
      : DEFAULT_REQUEST_CONFIG;

    createRequest.mutate(
      { id, token },
      {
        onSuccess: () => Toast.success({ message: successMessage }),
        onSettled: () => history.replace(redirectTo),
      },
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="fixed w-full h-screen flex justify-center items-center">
      <CircularProgress />
    </div>
  );
};
